module.exports = process.env.PROMISE_QUEUE_COVERAGE ?
    require('./lib-cov') :
    require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/promise-queue/index.js
// module id = ./node_modules/promise-queue/index.js
// module chunks = 53 54